import { IndividualScheduleRepository } from "@/repositories/individual-schedule.repository";
import { availabilityDaysOf, weeklyScheduleOf, type WeeklySchedule } from "@/models/individual-schedule.model";
import { uuid } from "@/interfaces";

export const scheduleApi = {
  async getSchedule(contract: uuid): Promise<WeeklySchedule> {
    const { days } = await IndividualScheduleRepository.mine(contract);
    return weeklyScheduleOf(days);
  },

  async saveSchedule(contract: uuid, schedule: WeeklySchedule): Promise<WeeklySchedule> {
    const { days } = await IndividualScheduleRepository.saveMine(contract, availabilityDaysOf(schedule));
    return weeklyScheduleOf(days);
  },
};
